import React, { useEffect, useState } from 'react';
import { usePage } from '@inertiajs/react';
import { defaultJmsColor, isCheckColorWhite } from '@Utils/colorUtils';

export function useDynamicButtonStyle(themeButtonStyleProps?: React.CSSProperties | undefined) {
  const { props } = usePage();
  const auth = props?.auth as Auth | undefined;


  // Get banner color safely
  const bannerColor = auth?.company?.settings?.banner_color || defaultJmsColor;

  const [colorButton, setColorButton] = useState<string>(bannerColor);

  useEffect(() => {
    if (isCheckColorWhite(bannerColor)) {
      setColorButton(defaultJmsColor);
    }
  }, [bannerColor]);

  return bannerColor ? { background: colorButton } : (themeButtonStyleProps ?? {});
}
